// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 *
 * @param selector
 * @param delta
 * @param containerElement: it needs position relative or absolute
 */

export function initializeScrollTo(selector: string, delta = 0, containerElement?: HTMLElement) {
    const stepSize = 25;
    const startY = currentYPosition();
    let elmY = elmYPosition(selector, containerElement) + delta;
    elmY = elmY > 0 ? elmY : 0;
    const stopY = elmY - stepSize > 0 ? elmY - stepSize : elmY;

    if (containerElement) {
        (containerElement as any).scrollTop = stopY;
        return;
    }

    const distance = stopY > startY ? stopY - startY : startY - stopY;
    if (distance < 100) {
        window.scrollTo(0, stopY);
        return;
    }
    let speed = Math.round(distance / 100);
    if (speed >= 20) {
        speed = 20;
    }
    const step = Math.round(distance / stepSize);
    let leapY = stopY > startY ? startY + step : startY - step;
    let timer = 0;
    if (stopY > startY) {
        for (let i = startY; i < stopY; i += step) {
            setTimeout((y => () => window.scrollTo(0, y))(leapY), timer * speed);
            leapY += step;
            if (leapY > stopY) {
                leapY = stopY;
            }
            timer++;
        }
        return;
    }
    for (let i = startY; i > stopY; i -= step) {
        setTimeout((y => () => window.scrollTo(0, y))(leapY), timer * speed);
        leapY -= step;
        if (leapY < stopY) {
            leapY = stopY;
        }
        timer++;
    }
}

function currentYPosition() {
    if (window.pageYOffset) {
        return window.pageYOffset;
    }
    return 0;
}

function elmYPosition(selector: string, containerElement?: HTMLElement): number {
    const arr: NodeListOf<Element> = document.querySelectorAll(selector);
    if (arr.length === 0) {
        return 0;
    }
    const elm: any = arr[0];

    const header = document.querySelector("header") as any;
    const headerHeight = header?.offsetHeight;

    let y = elm.offsetTop;
    if (!containerElement) {
        y = elm.offsetTop - 85;
        if (headerHeight) {
            y = elm.offsetTop - headerHeight;
        }
    }

    let node: any = elm;
    const parentNode = containerElement || document.body;
    while (node.offsetParent && node.offsetParent !== parentNode) {
        node = node.offsetParent;
        y += node.offsetTop;
    }
    return y;
}
